module.exports = __webpack_public_path__ + "static/media/left-arrow-to-left.180b4c51.svg";